import { BusinessObjectBase } from './base';
import type { Position } from './position';
import type { TrainingClass } from './training-class';

export interface VenueData {
  readonly id: string;
  readonly name?: string;
  readonly address?: string;
  readonly positions?: Position[];
  readonly trainingClasses?: TrainingClass[];
}

export interface Venue extends Readonly<VenueData> {}
export class Venue extends BusinessObjectBase {
  static readonly entityName = 'Venue' as const;
  static readonly plural = 'venues';

  // --- Static CRUD methods ---

  static async find(filter?: any): Promise<Venue[]> {
    const url = `${this.baseUrl}/${this.plural}`;
    const params: Record<string, string> = {};
    if (filter) params['filter'] = JSON.stringify(filter);
    const results = await this.get<any[]>(url, params);
    return results.map((data) => new Venue(data));
  }

  static async findOne(filter?: any): Promise<Venue | null> {
    const url = `${this.baseUrl}/${this.plural}/find-one`;
    const params: Record<string, string> = {};
    if (filter) params['filter'] = JSON.stringify(filter);
    const data = await this.get<any>(url, params);
    return data ? new Venue(data) : null;
  }

  static async findById(id: string, filter?: any): Promise<Venue> {
    const url = `${this.baseUrl}/${this.plural}/${id}`;
    const params: Record<string, string> = {};
    if (filter) params['filter'] = JSON.stringify(filter);
    const data = await this.get<any>(url, params);
    return new Venue(data);
  }

  static async create(data: Omit<VenueData, 'id'>): Promise<Venue> {
    const url = `${this.baseUrl}/${this.plural}`;
    const result = await this.post<any>(url, data);
    return new Venue(result);
  }

  static async updateById(
    id: string,
    data: Partial<VenueData>,
  ): Promise<Venue> {
    const url = `${this.baseUrl}/${this.plural}/${id}`;
    const result = await this.patch<any>(url, data);
    return new Venue(result);
  }

  static async deleteById(id: string): Promise<boolean> {
    const url = `${this.baseUrl}/${this.plural}/${id}`;
    try {
      await this.del<void>(url);
      return true;
    } catch {
      return false;
    }
  }
}
